export const companyCN = {
  name: '公司名称',
  nameEn: '公司名称(英文)',
  address: '公司地址',
  phone: '公司电话',
  platform: '公司平台',
  entity: '公司实体',
  emails: '公司邮箱',
  addressEn: '公司地址(英文)',
  postalCode: '邮政编码',
  brn: '营业执照号',
  tin: '税务登记号',
  bankName: '开户银行',
  bankAddress: '开户银行地址',
  bankAccountName: '开户银行账户名',
  bankAccountNumber: '开户银行账户号',
  swiftCode: 'SWIFT代码',
  branchCode: '支行代码',
  tags: '标签',
  BusinessType: '业务类型',
  isHyperTAP: '是否网盟实体',
  companyEntityAlias: '公司实体别名',
};

export const companyEN = {
  name: 'Company Name',
  nameEn: 'Company Name(English)',
  address: 'Company Address',
  phone: 'Company Phone',
  platform: 'Company Platform',
  entity: 'Company Entity',
  emails: 'Company Email',
  addressEn: 'Company Address(English)',
  postalCode: 'Postal Code',
  brn: 'Business Registration Number',
  tin: 'Tax Identification Number',
  bankName: 'Bank Name',
  bankAddress: 'Bank Address',
  bankAccountName: 'Bank Account Name',
  bankAccountNumber: 'Bank Account Number',
  swiftCode: 'Swift Code',
  branchCode: 'Branch Code',
  tags: 'Tags',
  BusinessType: 'Business Type',
  isHyperTAP: 'Is HyperTAP Entity',
  companyEntityAlias: 'Company Entity Alias',
};
